<template>
  <v-tooltip top :disabled="!label">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :disabled="!!disabled"
        :loading="!!loading"
        :small="small"
        icon
        @click="$emit('click')"
      >
        <v-badge :value="checked" color="success" overlap bottom>
          <template v-slot:badge class="d-flex align-center justify-center">
            <v-icon size="10" style="width: 4px; height: 4px">mdi-check</v-icon>
          </template>
          <v-icon>{{ icon }}</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    small: Boolean,
    loading: Boolean,
    disabled: Boolean,
    icon: String,
    checked: Boolean,
    label: String,
  },
};
</script>
